module.exports = __webpack_public_path__ + "img/pattern-col-blue.00d5378d.png";